const updateFilters = (state, payload) => {
  state.filters = payload
}

export default {
  updateFilters
}
